import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  Grid,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Book as BookIcon,
  Assessment as AssessmentIcon,
  Google as GoogleIcon,
  CloudUpload as UploadIcon,
  GridView as GridViewIcon,
  Message as MessageIcon,
  Group as GroupIcon,
  Dashboard as DashboardIcon,
  SmartToy as AIIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";

import { Grading as GradingIcon } from "@mui/icons-material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SchoolIcon from "@mui/icons-material/School";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";

import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import EditIcon from "@mui/icons-material/Edit";
import MicIcon from "@mui/icons-material/Mic";

export const features = [
  {
    title: "Bedömning",
    description: "Bedöm texter med AI",
    icon: AssignmentTurnedInIcon,
    path: "/bedomning",
  },

  {
    title: "Lektioner",
    description: "Generera lektioner med AI",
    icon: SchoolIcon,
    path: "/lektioner",
  },
  {
    title: "Quiz",
    description: "Generera quiz med AI",
    icon: PsychologyIcon,
    path: "/quiz",
  },
  {
    title: "Flashcards",
    description: "Generera flashcards med AI",
    icon: ViewAgendaIcon,
    path: "/flashcards",
  },

  {
    title: "Lektionsplanering",
    description: "Generera lektionsplanering med AI",
    icon: CalendarMonthIcon,
    path: "/lektionsplanering",
  },

  {
    title: "Podcast",
    description: "Generera podcasts med AI",
    icon: MicIcon,
    path: "/podcast",
  },
  {
    title: "Högskoleprovet",
    description: "Öva på gamla högskoleprov",
    icon: HistoryEduIcon,
    path: "/hogskoleprovet",
  },

  {
    title: "Assistenter",
    description: "Skapa egna AI-assistenter",
    icon: SmartToyIcon,
    path: "/assistenter",
  },

  // {
  //   title: "Hjälpmedel",
  //   description: "Utforska fler hjälpmedel",
  //   icon: GoogleIcon,
  //   path: "/hjalpmedel",
  // },

  {
    title: "Bilder",
    description: "Generera bilder med AI",
    icon: AddPhotoAlternateIcon,
    path: "/bilder",
  },

  // {
  //   title: "Generera PowerPoint",
  //   description: "Generera PowerPoints med AI",
  //   icon: SlideshowIcon,
  //   path: "/powerpoint",
  // },

  // {
  //   title: "Textlabbet",
  //   description: "Manipulera text med AI",
  //   icon: EditIcon,
  //   path: "/textlabbet",
  // },
];

const FeaturesSubmenu = ({ onClose, theme }) => {
  const navigate = useNavigate();
  return (
    <Paper
      elevation={0}
      onMouseEnter={(e) => {
        e.stopPropagation();
        if (onClose) clearTimeout(onClose.timeoutId);
      }}
      sx={{
        position: "absolute",
        top: "100%",
        right: -180, // Changed from 0 to -100 to move it more to the right
        width: 1000,
        background: "#f9f9f9",
        backdropFilter: "blur(16px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        boxShadow:
          "0 26px 58px 0 rgba(0, 0, 0, .18), 0 5px 14px 0 rgba(0, 0, 0, .15) !important",
        zIndex: 2000,
        borderRadius: "16px",
        p: 3,
        opacity: 0,
        animation: "fadeIn 0.3s ease-out forwards",
        "&.closing": {
          animation: "fadeOut 0.25s ease-out forwards",
        },
        "@keyframes fadeIn": {
          "0%": {
            opacity: 0,
            transform: "translateY(10px)",
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
        "@keyframes fadeOut": {
          "0%": {
            opacity: 1,
            transform: "translateY(0)",
          },
          "100%": {
            opacity: 0,
            transform: "translateY(10px)",
          },
        },
      }}
    >
      {" "}
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a1a" }}>
          Våra funktioner
        </Typography>
      </Box>
      <Grid container spacing={1.2}>
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <Grid item xs={6} md={4} key={index}>
              <Link
                to={feature.path}
                style={{ textDecoration: "none" }}
                onClick={() => {
                  if (onClose) onClose();
                }}
              >
                <Box
                  sx={{
                    py: 3,
                    px: 1.8,
                    borderRadius: 3,
                    cursor: "pointer",
                    background: "#ffffff",
                    border: "1px solid #e9ecef",
                    transition: "all 0.18s ease",
                    "&:hover": {
                      borderColor: "primary.main",
                      boxShadow: "0 2px 6px rgba(33, 150, 243, 0.12)",
                      background: "#f9fbff",
                    },
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: 30,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 1.5,
                    }}
                  >
                    <IconComponent
                      sx={{ fontSize: "26px", color: "#1565c0" }}
                    />
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "#263238",
                        fontSize: "1rem",
                        lineHeight: 1.2,
                      }}
                    >
                      {feature.title}
                    </Typography>
                  </Box>
                </Box>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
};

export default FeaturesSubmenu;
